// extracted by mini-css-extract-plugin
export default {"cardSec":"CertificateActivityLogs_cardSec__bENy2","certificateImgSec":"CertificateActivityLogs_certificateImgSec__wNMdS","downloadBtn":"CertificateActivityLogs_downloadBtn__cvQXH"};